import { gql, TypedDocumentNode } from '@apollo/client'
import { MassUploadSummaryResponse } from '../type'

export const MassUploadSummary: TypedDocumentNode<{massUploadSummary: MassUploadSummaryResponse}, {directoryId: string}> = gql`
    query MassUploadSummary($directoryId: String!) {
        massUploadSummary(directoryId: $directoryId)
    }
`

export const MassUploadAddSkuDoNotHaveAnyImagesMutation: TypedDocumentNode<void, {directoryId: string}> = gql`
    mutation AddSkuDoNotHaveAnyImages($directoryId: String!) {
        massUploadAddSkuDoNotHaveAnyImages(directoryId: $directoryId)
    }
`

export const MassUploadAddDifferentImagesToItemsMutation: TypedDocumentNode<void, {directoryId: string}> = gql`
    mutation AddDifferentImagesToItems($directoryId: String!) {
        massUploadAddDifferentImagesToItems(directoryId: $directoryId)
    }
`

export const MassUploadReplaceDuplicatedMutation: TypedDocumentNode<void, {directoryId: string}> = gql`
    mutation ReplaceDuplicated($directoryId: String!) {
        massUploadReplaceDuplicated(directoryId: $directoryId)
    }
`